// Dependecies
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Hooks
import useLanguage from '../useLanguage';

function useRecoveryPassword() {
  const [t] = useTranslation('routers', { useSuspense: false });
  const { locale } = useLanguage();
  const [messageError, setMessageError] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  const history = useHistory();

  const submit = async (values) => {
    try {
      const options = {
        method: 'POST',
        body: JSON.stringify({
          email: values.email,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await fetch(`/api/auth/recover_password?lang=${locale}`, options);
      const trainingResponse = await response.json();

      if (trainingResponse.success === true) {
        if (response.status !== 200) {
          if (response.status === 401) {
            setMessageError(t('access'));
          }
        } else {
          setOpenModal(true);
        }
      } else if (trainingResponse.error.email) {
        setMessageError(t('no-email'));
      } else {
        setMessageError(trainingResponse.error);
      }
    } catch (e) {
      setMessageError(t('error'));
    }
  };

  const closeModal = () => {
    setOpenModal(false);
    history.push(`${t('Login')}`);
  };

  return {
    openModal,
    closeModal,
    submit,
    messageError,
  };
}

export default useRecoveryPassword;
